import { useParams, Navigate, Link } from 'react-router-dom';
import { Header } from '../components/Header.jsx';
import { Footer } from '../components/Blocks.jsx';

/* Placeholder for the per-language schools pages (/schools/:lang),
 * linked from the /schools1 cross-link bar. Aran's per-language
 * content is on its way (Irish first, then the MFL four); each slug
 * here graduates to a full route file when its copy lands, mirroring
 * SchoolsWelsh.jsx.
 *
 * No Tweaks panel — nothing here is worth editing before the real
 * content replaces it. Chrome copy matches SchoolsWelsh.jsx.
 */
// All five launch languages graduated to full routes (2026-07-09):
// SchoolsIrish/Spanish/French/German/Italian.jsx. Add future languages
// here to give them a placeholder before their page is built.
const LANGS = {};

const CHROME = {
  navWelshResources: 'Welsh Resources',
  navCommunity: 'Community',
  navAboutUs: 'About us',
  navBlog: 'Blog',
  navContact: 'Contact',
  login: 'Login',
  startLearning: 'Start Learning',
  footerCol1: 'The product',
  footerCol2: 'Community',
  footerCol3: 'Download',
  footerAbout: 'About',
  footerCareers: 'Careers',
  footerContact: 'Contact',
  footerHelp: 'Help centre',
  footerTerms: 'Terms',
  footerPrivacy: 'Privacy',
  footerAppHeading: 'Download',
  footerAppApple: 'iOS',
  footerAppGoogle: 'Android',
  footerLivingWage: 'We are a Living Wage Employer',
  footerCopyright: '© 2025 SaySomethingin Cyf',
  footerLegal: '© 2026 SaySomethingIn Cyf. Glaslyn, Ffordd y Parc, Bangor, Gwynedd LL57 4FE, Wales.',
};

export default function SchoolsLangSoon() {
  const { lang } = useParams();
  const name = LANGS[(lang || '').toLowerCase()];
  if (!name) return <Navigate to="/schools1" replace/>;
  return (
    <div data-screen-label={`Schools — ${name} (placeholder)`}>
      <Header t={CHROME}/>
      <main>
        <section style={st.wrap}>
          <div style={st.inner}>
            <div style={st.kicker}>SaySomethingin for schools</div>
            <h1 style={st.h1}>{name} for your school – this page is on its way.</h1>
            <p style={st.sub}>
              We're building the {name} schools page right now. Everything about
              how SaySomethingin works in a classroom – the method, the free
              trial, the research – is on our Welsh schools page, and the same
              approach applies to {name}. Or talk to us directly and we'll take
              it from there.
            </p>
            <div style={st.ctaRow}>
              <Link to="/schools1" className="btn btn--primary">See how it works in schools</Link>
              <Link to="/contact" style={st.ghost}>Talk to the schools team →</Link>
            </div>
          </div>
        </section>
      </main>
      <Footer t={CHROME} hideCta={true}/>
    </div>
  );
}

const st = {
  wrap: { background:'var(--offWhite)', padding:'96px 32px 120px' },
  inner: { maxWidth:760, margin:'0 auto', textAlign:'center' },
  kicker: { fontSize:12, letterSpacing:'.16em', textTransform:'uppercase', color:'var(--brandRed)', fontWeight:700, marginBottom:18 },
  h1: { font:'700 52px/1.1 var(--font-display)', margin:'0 0 20px', color:'var(--fg-1)', letterSpacing:'-.01em' },
  sub: { font:'400 18px/1.6 var(--font-body)', color:'var(--fg-2)', margin:'0 0 32px' },
  ctaRow: { display:'flex', alignItems:'center', justifyContent:'center', gap:24, flexWrap:'wrap' },
  ghost: { color:'var(--brandRed)', fontSize:15, fontWeight:600, textDecoration:'none' },
};
